import React from "react";
import { LOGO_WHITE_URL } from "../../data";

// White transparent supplied logo + "PRODUCTIONS" lockup.
export const Logo = ({
  className = "",
  glow = true,
  showProductions = false,
  productionsClassName = "",
}) => (
  <span className="relative inline-flex flex-col items-start">
    {glow && (
      <span className="absolute -inset-4 -z-10 blur-[40px] bg-[#b533ff]/40 rounded-full" />
    )}
    <img
      src={LOGO_WHITE_URL}
      alt="Rock Chicks Productions"
      draggable={false}
      className={`w-auto ${className}`}
    />
    {showProductions && (
      <span
        className={`font-display font-semibold uppercase text-white/85 flex items-center gap-3 ${productionsClassName}`}
      >
        <span className="h-px w-8 bg-[#b533ff]" />
        Productions
      </span>
    )}
  </span>
);
